<template>
  <svg
    v-if="gSiteName === 'xoilaczxc'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="as-not-change-color"
  >
    <g clip-path="url(#clip0_15_4687)">
      <path
        d="M5.83337 10.8333V18.3333C5.83337 18.5544 5.74558 18.7663 5.5893 18.9226C5.43302 19.0789 5.22105 19.1667 5.00004 19.1667H1.66671C1.44569 19.1667 1.23373 19.0789 1.07745 18.9226C0.921171 18.7663 0.833374 18.5544 0.833374 18.3333V10.8333C0.833374 10.6123 0.921171 10.4004 1.07745 10.2441C1.23373 10.0878 1.44569 10 1.66671 10H5.00004C5.22105 10 5.43302 10.0878 5.5893 10.2441C5.74558 10.4004 5.83337 10.6123 5.83337 10.8333ZM11.6667 0.833344H8.33337C8.11236 0.833344 7.9004 0.921141 7.74412 1.07742C7.58784 1.2337 7.50004 1.44566 7.50004 1.66668V18.3333C7.50004 18.5544 7.58784 18.7663 7.74412 18.9226C7.9004 19.0789 8.11236 19.1667 8.33337 19.1667H11.6667C11.8877 19.1667 12.0997 19.0789 12.256 18.9226C12.4122 18.7663 12.5 18.5544 12.5 18.3333V1.66668C12.5 1.44566 12.4122 1.2337 12.256 1.07742C12.0997 0.921141 11.8877 0.833344 11.6667 0.833344ZM18.3334 5.00001H15C14.779 5.00001 14.5671 5.08781 14.4108 5.24409C14.2545 5.40037 14.1667 5.61233 14.1667 5.83334V18.3333C14.1667 18.5544 14.2545 18.7663 14.4108 18.9226C14.5671 19.0789 14.779 19.1667 15 19.1667H18.3334C18.5544 19.1667 18.7664 19.0789 18.9226 18.9226C19.0789 18.7663 19.1667 18.5544 19.1667 18.3333V5.83334C19.1667 5.61233 19.0789 5.40037 18.9226 5.24409C18.7664 5.08781 18.5544 5.00001 18.3334 5.00001Z"
        fill="#7E8793"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_4687">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else-if="gSiteName === 'xoilactivi'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="as-not-change-color"
  >
    <g clip-path="url(#clip0_491_518)">
      <path
        d="M5.8335 10.8334V18.3334C5.8335 18.5544 5.7457 18.7664 5.58942 18.9226C5.43314 19.0789 5.22118 19.1667 5.00016 19.1667H1.66683C1.44582 19.1667 1.23385 19.0789 1.07757 18.9226C0.921293 18.7664 0.833496 18.5544 0.833496 18.3334V10.8334C0.833496 10.6124 0.921293 10.4004 1.07757 10.2441C1.23385 10.0878 1.44582 10 1.66683 10H5.00016C5.22118 10 5.43314 10.0878 5.58942 10.2441C5.7457 10.4004 5.8335 10.6124 5.8335 10.8334ZM11.6668 0.833374H8.3335C8.11248 0.833374 7.90052 0.921171 7.74424 1.07745C7.58796 1.23373 7.50016 1.44569 7.50016 1.66671V18.3334C7.50016 18.5544 7.58796 18.7664 7.74424 18.9226C7.90052 19.0789 8.11248 19.1667 8.3335 19.1667H11.6668C11.8878 19.1667 12.0998 19.0789 12.2561 18.9226C12.4124 18.7664 12.5002 18.5544 12.5002 18.3334V1.66671C12.5002 1.44569 12.4124 1.23373 12.2561 1.07745C12.0998 0.921171 11.8878 0.833374 11.6668 0.833374ZM18.3335 5.00004H15.0002C14.7792 5.00004 14.5672 5.08784 14.4109 5.24412C14.2546 5.4004 14.1668 5.61236 14.1668 5.83337V18.3334C14.1668 18.5544 14.2546 18.7664 14.4109 18.9226C14.5672 19.0789 14.7792 19.1667 15.0002 19.1667H18.3335C18.5545 19.1667 18.7665 19.0789 18.9228 18.9226C19.079 18.7664 19.1668 18.5544 19.1668 18.3334V5.83337C19.1668 5.61236 19.079 5.4004 18.9228 5.24412C18.7665 5.08784 18.5545 5.00004 18.3335 5.00004Z"
        fill="#B4BEC1"
      />
      <path
        d="M11.6667 0.833496H8.33333C8.11232 0.833496 7.90036 0.921293 7.74408 1.07757C7.5878 1.23385 7.5 1.44582 7.5 1.66683V18.3335C7.5 18.5545 7.5878 18.7665 7.74408 18.9228C7.90036 19.079 8.11232 19.1668 8.33333 19.1668H11.6667C11.8877 19.1668 12.0996 19.079 12.2559 18.9228C12.4122 18.7665 12.5 18.5545 12.5 18.3335V1.66683C12.5 1.44582 12.4122 1.23385 12.2559 1.07757C12.0996 0.921293 11.8877 0.833496 11.6667 0.833496Z"
        fill="#00FF5E"
      />
    </g>
    <defs>
      <clipPath id="clip0_491_518">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="3" y="7" width="3" height="10" fill="#9C9C9C" />
    <rect x="8" y="3" width="3" height="14" fill="#9C9C9C" />
    <rect x="13" y="6" width="3" height="11" fill="#9C9C9C" />
  </svg>
</template>
<script lang="ts">
export default {};
</script>
